var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1859_65296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 24H8C6.9 24 6 23.1 6 22V8C6 6.9 6.9 6 8 6H22C23.1 6 24 6.9 24 8V18H22V8H8V22H18V24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 18H26V16H28V13H26V11H28C29.1 11 30 11.9 30 13V16C30 17.1 29.1 18 28 18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 18H2C0.9 18 0 17.1 0 16V13C0 11.9 0.9 11 2 11H4V13H2V16H4V18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10H10V14H12V10Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 10H18V14H20V10Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 1H26V9H28V1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 1H2V9H4V1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 20C13.35 20 12 18.65 12 17V16H14V17C14 17.55 14.45 18 15 18C15.55 18 16 17.55 16 17V16H18V17C18 18.65 16.65 20 15 20Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9469 31.32L26.0469 30.68L27.2769 27H29.9969V29H28.7169L27.9469 31.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.95 31.3198L26.05 30.6898L27.05 27.6898C27.19 27.2798 27.57 27.0098 28 27.0098H30V22.0098H22V27.0098H25V29.0098H22C20.9 29.0098 20 28.1098 20 27.0098V22.0098C20 20.9098 20.9 20.0098 22 20.0098H30C31.1 20.0098 32 20.9098 32 22.0098V27.0098C32 28.1098 31.1 29.0098 30 29.0098H28.72L27.95 31.3297V31.3198Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1859_65296"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat-icon.80a2713ecce914a625003fa3c5025628.svg";
export { ForwardRef as ReactComponent };